<template>
  <span>
    <div class="content-container">
      <div class="content">
        <h1 class="main-intro-header wide-letter-spacing mb-3">
          <span class="dark-background-accent">&lt;</span> 
          <span class="mx-3">Andy Truong</span> 
          <span class="dark-background-accent">/&gt;</span>
        </h1>
        <h2 class="main-intro-sub-header wide-letter-spacing">
          Full Stack Software Developer
        </h2>
      </div>
    </div>
  </span>
</template>

<script>
  export default {
    name: 'Home',
  }
</script>

<style lang="scss">
@import 'src/assets/scss/global.scss';

@import url('https://fonts.googleapis.com/css2?family=Lato:wght@400;700&display=swap');

.main-intro-header {
  font-size: 2rem;
}

.main-intro-sub-header {
  font-size: 1rem;
}

@media screen and (min-width: 450px)
{
  .main-intro-header {
    font-size: 3rem;
  }

  .main-intro-sub-header {
    font-size: 1.2rem;
  }
}

@media screen and (min-width: 600px)
{
  .main-intro-header {
    font-size: 4rem;
  }

  .main-intro-sub-header {
    font-size: 1.6rem;
  }
}

@media screen and (min-width: 1030px)
{
  .main-intro-header {
    font-size: 5rem;
  }

  .main-intro-sub-header {
    font-size: 1.8rem;
  }
}

.content-container {
  background-color: $background;
  background-image: linear-gradient(to bottom right, $background, $accent 1500%);
  position: fixed;
  height: 100vh;
  width: 100vw;
  top: 0px;
  left: 0px;
  z-index: 1;
  
  display: flex;
  justify-content: center;
  align-items: center;
}

.content {
  text-align: center;
  color: $contentText;
}

</style>


